import { IconComponentProps } from '../IconTypes';

const ScoreCircleFull = ({ className }: IconComponentProps) => (
  <svg
    className={className}
    fill="currentColor"
    height="14"
    viewBox="0 0 14 14"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="7.00065" cy="6.99992" fill="currentColor" r="6.66667" />
  </svg>
);

export default ScoreCircleFull;
